import React from 'react';
import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';

import AjaxService from '../../Services/Ajax/index.jsx';

import CMSContent from '../CMSContent/index.jsx';
import LoadingOverlay from '../LoadingOverlay/index.jsx';

import BEM from '@scripts/utilities/bem.js';


class CheckoutDurationSelectorWebinar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      current: undefined,
      loading: false,
      error: null
    };

    this.body = undefined;

    this.onPostComplete = this.onPostComplete.bind(this);
  }

  handleClick(variantId) {
    this.setState({
      loading: true,
      error: null,
      current: variantId
    });

    AjaxService.post('cs:checkout-duration-selector', 'variant=' + variantId)
      .then(this.onPostComplete);
  }

  componentDidMount() {
    this.body = jQuery(document.body);
  }

  onPostComplete(response) {
    var newState = { loading: false };

    if (response.error) {
      newState.error = response.message;
    } else {
      newState.current = response.data;
      newState.error = null;

      // tell the rest of the checkout process that things have changed.
      this.body.trigger('update_checkout', { update_shipping_method: false });
    }

    this.setState(newState);
  }

  render() {
    var content = [];
    var groups = [];

    if (this.state.error) {
      content.push(
        <Alert key="error" variant="danger">
          <Alert.Heading>Error:</Alert.Heading>
          {this.state.error}
        </Alert>
      )
    }

    var current = this.props.current;
    if (this.state.current) {
      current = this.state.current;
    }

    if (this.props.group) {
      var currency = this.props.currency;

      for (var i = 0; i < this.props.group.length; i++) {
        var group = this.props.group[i];

        var checked = (group.id == current);
        var description = undefined;
        if (group.description) {
          description = (
            <span dangerouslySetInnerHTML={{ __html: group.description }} />
          );
        }

        var variant = undefined;
        if (group.featured) {
          variant = 'featured';
        }

        groups.push(
          <div key={i} className={BEM.classString('cs-checkout-duration-selector-webinar', variant)}>
            <Form.Check
              custom
              id={"duration-selector-" + i}
              type="radio"
              label={group.title}
              value={group.id}
              checked={checked}
              onChange={(event) => this.handleClick(event.target.value)}
            />
            {description}
          </div>
        );
      }
    }

    content.push(
      <LoadingOverlay key="content" disabled={! this.state.loading}>
        {groups}
      </LoadingOverlay>
    );

    return content;
  }
}


export default CheckoutDurationSelectorWebinar;

